export default {"src":"/_next/static/media/copy.020f955a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};